import React from 'react';
import Cookies from 'js-cookie'
import { ResultsDataContext } from '../DataContext';


const openAndFetchIfNeeded = (formContext, question, setOpen, answers) => {
  setOpen(true);
  // if (answers === undefined) {
  formContext.requestFreetextAnswers(question.id)
  // }
}

const setAnswerShared = (answerId, shared) => {
  return fetch(`/api/v1/results/share-freetext-answer/${answerId}`, {
    method: shared ? 'POST' : 'DELETE',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: {
      'X-CSRFToken': Cookies.get('csrftoken'),
    },
  }).then(response => {
    // DELETE of an already unshared answer gives 404, which is the desired end state
    if (!response.ok && !(response.status === 404 && !shared)) {
      throw new Error(`Sharing answer ${answerId} failed with status ${response.status}`)
    }
  })
}

const FreetextAnswer = ({ answer, index }) => {
  const [shared, setShared] = React.useState(answer.shared)
  const [saving, setSaving] = React.useState(false)

  const toggleShared = (ev) => {
    const newShared = ev.target.checked
    setShared(newShared)
    setSaving(true)
    setAnswerShared(answer.id, newShared)
      .then(() => { answer.shared = newShared })
      .catch((err) => {
        console.error(err)
        setShared(!newShared)
        alert(I18N._('Failed to change sharing of the answer'))
      })
      .finally(() => setSaving(false))
  }

  return (
    <div className={"freetext " + (index % 2 == 0 ? 'even' : 'odd')} title={answer.text}>
      <input
        type="checkbox"
        className="share-checkbox"
        checked={shared}
        disabled={saving}
        onChange={toggleShared}
        title={I18N._('Share this answer when sharing the results of this form')}
        aria-label={I18N._('Share this answer when sharing the results of this form')}
      />
      <span className="freetext__text">{answer.text}</span>
    </div>
  )
}

const _FreetextAnswers = ({ question, formContext }) => {

  const [opened, setOpen] = React.useState(false)
  const answers = formContext.freetextAnswers[question.id]
  const enoughAnswers = answers && answers !== "Not enough answers"

  return (
    <div className="answer-row">
      {
        <div className={"freetext-container " + (opened ? "open" : "")}>
          <div className="header">
            <button
              onClick={() => opened ? setOpen(false) : openAndFetchIfNeeded(formContext, question, setOpen, answers)}
              className="btn btn-sm btn-default">
              {
                opened ?
                  <>
                    {I18N._('Hide answers')}
                    <span className="glyphicon glyphicon-minus" aria-hidden="true"></span>
                  </>
                  :
                  <>
                    {I18N._('View answers')}
                    <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
                  </>

              }
            </button>
          </div>
          {
            opened &&
            <div>
              {
                answers === undefined ?
                  <div> Fetching freetext answers </div>
                  :
                  enoughAnswers ?
                    answers.map((a, i) =>
                      <FreetextAnswer answer={a} index={i} key={a.id} />
                    ) :
                    <div className="no-results"> {I18N._('There are no results')} </div>
              }
            </div>
          }
        </div>
      }
    </div>
  )
}


export const SharedFreetextAnswers = ({ answers }) => {
  return (
    <div className="answer-row">
      <div className="freetext-container open">
        {
          answers.map((text, i) =>
            <div className={"freetext " + (i % 2 == 0 ? 'even' : 'odd')} key={i} title={text}>
              <span className="freetext__text">{text}</span>
            </div>
          )
        }
      </div>
    </div>
  )
}


const FreetextAnswers = ({ question }) => {
  return <ResultsDataContext.Consumer>
    {formContext =>
      <_FreetextAnswers formContext={formContext} question={question} key={formContext.counter} />
    }
  </ResultsDataContext.Consumer>
}

FreetextAnswers.defaultProps = {
  question: {},
}

export default FreetextAnswers

